import { Channel } from '../../../../models/channel.enum';
import { TravellerCategory } from '../../../../models/traveller-category.enum';
import SalesChannelPrice from './sales-channel-price';
import { type ITicketSuggestion } from '../../../../models/ticket-suggestion.model';
import { ProductType } from '../../../../models/product-type.enum';
import SingleTicketGrouping from './single-ticket-grouping';

export default class TicketSuggestionGroup {
  public name!: string;
  public validityTimeMinutes: number | undefined;
  public adultTapAndGoSalesChannelPrice!: SalesChannelPrice;
  public adultTogoSalesChannelPrice!: SalesChannelPrice;
  public adultOmbordSalesChannelPrice!: SalesChannelPrice;
  public adultOmbudSalesChannelPrice!: SalesChannelPrice;

  public youthTapAndGoSalesChannelPrice!: SalesChannelPrice;
  public youthTogoSalesChannelPrice!: SalesChannelPrice;
  public youthOmbordSalesChannelPrice!: SalesChannelPrice;
  public youthOmbudSalesChannelPrice!: SalesChannelPrice;

  public productType: ProductType;

  public singleTicketGroupings: SingleTicketGrouping[] = [];

  public hasTravellerCategory: TravellerCategory[] = [];

  constructor(productType: ProductType) {
    this.productType = productType;
  }

  public getComparePrice(travellerCategory: TravellerCategory): number {
    if (travellerCategory === TravellerCategory.adult) {
      return this.adultTogoSalesChannelPrice?.priceInSek ?? 0;
    }
    if (travellerCategory === TravellerCategory.youth) {
      return this.youthTogoSalesChannelPrice?.priceInSek ?? 0;
    }

    return 0;
  }

  public addPriceAndValidity(ticketSuggestion: ITicketSuggestion, name?: string) {
    if (this.name == null) {
      this.name = name ?? '';
    }

    if (this.hasTravellerCategory.find((f) => f === ticketSuggestion.travellerCategory) === undefined) {
      this.hasTravellerCategory.push(ticketSuggestion.travellerCategory);
    }

    ticketSuggestion.saleChannels.forEach((saleChannel) => {
      if (saleChannel.id === Channel.toGo) {
        if (ticketSuggestion.travellerCategory === TravellerCategory.adult) {
          this.adultTogoSalesChannelPrice = new SalesChannelPrice(Channel.toGo, ticketSuggestion.priceInSek);
        } else if (ticketSuggestion.travellerCategory === TravellerCategory.youth) {
          this.youthTogoSalesChannelPrice = new SalesChannelPrice(Channel.toGo, ticketSuggestion.priceInSek);
        }
      } else if (saleChannel.id === Channel.ombord) {
        if (ticketSuggestion.travellerCategory === TravellerCategory.adult) {
          this.adultOmbordSalesChannelPrice = new SalesChannelPrice(Channel.ombord, ticketSuggestion.priceInSek);
        } else if (ticketSuggestion.travellerCategory === TravellerCategory.youth) {
          this.youthOmbordSalesChannelPrice = new SalesChannelPrice(Channel.ombord, ticketSuggestion.priceInSek);
        }
      } else if (saleChannel.id === Channel.ombud) {
        if (ticketSuggestion.travellerCategory === TravellerCategory.adult) {
          this.adultOmbudSalesChannelPrice = new SalesChannelPrice(Channel.ombud, ticketSuggestion.priceInSek);
        } else if (ticketSuggestion.travellerCategory === TravellerCategory.youth) {
          this.youthOmbudSalesChannelPrice = new SalesChannelPrice(Channel.ombud, ticketSuggestion.priceInSek);
        }
      }
    });
  }

  public addSingleTicketPrice(ticketSuggestion: ITicketSuggestion, validity: number): void {
    let singleTicket = this.singleTicketGroupings?.find((f) => f.ticketName === ticketSuggestion.productName && f.travellerCategory === ticketSuggestion.travellerCategory);
    if (singleTicket == null) {
      singleTicket = new SingleTicketGrouping(ticketSuggestion.productName, ticketSuggestion.travellerCategory, validity, ticketSuggestion.productInstanceType);
      this.singleTicketGroupings.push(singleTicket);
    }

    if (this.hasTravellerCategory.find((f) => f === ticketSuggestion.travellerCategory) === undefined) {
      this.hasTravellerCategory.push(ticketSuggestion.travellerCategory);
    }

    if (ticketSuggestion.travellerCategory === TravellerCategory.adult) {
      if ((ticketSuggestion.saleChannels.some((x) => x.id === Channel.toGo) && this.adultTogoSalesChannelPrice == null) || this.adultTogoSalesChannelPrice?.priceInSek > ticketSuggestion.priceInSek) {
        this.adultTogoSalesChannelPrice = new SalesChannelPrice(Channel.toGo, ticketSuggestion.priceInSek);
        singleTicket.salesChannels.push(this.adultTogoSalesChannelPrice);
      }
      if (
        (ticketSuggestion.saleChannels.some((x) => x.id === Channel.tapAndGo) && this.adultTapAndGoSalesChannelPrice == null) ||
        this.adultTapAndGoSalesChannelPrice?.priceInSek > ticketSuggestion.priceInSek
      ) {
        this.adultTapAndGoSalesChannelPrice = new SalesChannelPrice(Channel.tapAndGo, ticketSuggestion.priceInSek);
        singleTicket.salesChannels.push(this.adultTapAndGoSalesChannelPrice);
      }
      if (
        (ticketSuggestion.saleChannels.some((x) => x.id === Channel.ombord) && this.adultOmbordSalesChannelPrice == null) ||
        this.adultOmbordSalesChannelPrice?.priceInSek > ticketSuggestion.priceInSek
      ) {
        this.adultOmbordSalesChannelPrice = new SalesChannelPrice(Channel.ombord, ticketSuggestion.priceInSek);
        singleTicket.salesChannels.push(this.adultOmbordSalesChannelPrice);
      }
      if (
        (ticketSuggestion.saleChannels.some((x) => x.id === Channel.ombud) && this.adultOmbudSalesChannelPrice == null) ||
        this.adultOmbudSalesChannelPrice?.priceInSek > ticketSuggestion.priceInSek
      ) {
        this.adultOmbudSalesChannelPrice = new SalesChannelPrice(Channel.ombud, ticketSuggestion.priceInSek);
        singleTicket.salesChannels.push(this.adultOmbudSalesChannelPrice);
      }
    } else if (ticketSuggestion.travellerCategory === TravellerCategory.youth) {
      if ((ticketSuggestion.saleChannels.some((x) => x.id === Channel.toGo) && this.youthTogoSalesChannelPrice == null) || this.youthTogoSalesChannelPrice?.priceInSek > ticketSuggestion.priceInSek) {
        this.youthTogoSalesChannelPrice = new SalesChannelPrice(Channel.toGo, ticketSuggestion.priceInSek);
        singleTicket.salesChannels.push(this.youthTogoSalesChannelPrice);
      }
      if (
        (ticketSuggestion.saleChannels.some((x) => x.id === Channel.tapAndGo) && this.youthTapAndGoSalesChannelPrice == null) ||
        this.youthTapAndGoSalesChannelPrice?.priceInSek > ticketSuggestion.priceInSek
      ) {
        this.youthTapAndGoSalesChannelPrice = new SalesChannelPrice(Channel.tapAndGo, ticketSuggestion.priceInSek);
        singleTicket.salesChannels.push(this.youthTapAndGoSalesChannelPrice);
      }
      if (
        (ticketSuggestion.saleChannels.some((x) => x.id === Channel.ombord) && this.youthOmbordSalesChannelPrice == null) ||
        this.youthOmbordSalesChannelPrice?.priceInSek > ticketSuggestion.priceInSek
      ) {
        this.youthOmbordSalesChannelPrice = new SalesChannelPrice(Channel.ombord, ticketSuggestion.priceInSek);
        singleTicket.salesChannels.push(this.youthOmbordSalesChannelPrice);
      }
      if (
        (ticketSuggestion.saleChannels.some((x) => x.id === Channel.ombud) && this.youthOmbudSalesChannelPrice == null) ||
        this.youthOmbudSalesChannelPrice?.priceInSek > ticketSuggestion.priceInSek
      ) {
        this.youthOmbudSalesChannelPrice = new SalesChannelPrice(Channel.ombud, ticketSuggestion.priceInSek);
        singleTicket.salesChannels.push(this.youthOmbudSalesChannelPrice);
      }
    }
  }

  public hasChannelPrice(travellerCategory: TravellerCategory): boolean {
    if (travellerCategory === TravellerCategory.adult) {
      return (
        this.adultOmbordSalesChannelPrice !== undefined ||
        this.adultOmbudSalesChannelPrice !== undefined ||
        this.adultTogoSalesChannelPrice !== undefined ||
        this.adultTapAndGoSalesChannelPrice !== undefined
      );
    }
    if (travellerCategory === TravellerCategory.youth) {
      return (
        this.youthOmbordSalesChannelPrice !== undefined ||
        this.youthOmbudSalesChannelPrice !== undefined ||
        this.youthTogoSalesChannelPrice !== undefined ||
        this.youthTapAndGoSalesChannelPrice !== undefined
      );
    }

    return false;
  }
}
